import React, { createContext, useContext, useEffect, useState } from "react";
import { getApis } from "./components/common/api";
import { userOrganisationInfoUrl } from "./components/common/endpoints";
const OrganizationContext = createContext();

export default function OrganizationProvider({ children }) {
  const [organization, setOrganization] = useState({});

  const getOrgInfo = async () => {
    await getApis(userOrganisationInfoUrl)
      .then((response) => {
        setOrganization(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getOrgInfo();
  }, []);

  return (
    <OrganizationContext.Provider value={organization}>
      {children}
    </OrganizationContext.Provider>
  );
}

export function useOrganization() {
  return useContext(OrganizationContext);
}
